import AdminRole from './auth'
const SELECT_ALL = {
  value: 0,
  text: '全部'
}

const SELECT_ALLN = {
  value: -1,
  text: '全部'
}

const ADMINROLE = [
  {
    value: AdminRole.EDITOR,
    text: '运营'
  },
  {
    value: AdminRole.FINANCE,
    text: '财务'
  },
  {
    value: AdminRole.TECHNICAL,
    text: '技术'
  },
  {
    value: AdminRole.ADMIN_AD_MANAGE,
    text: '总监'
  },
  {
    value: AdminRole.ADMIN_AD_SPECIAL,
    text: '广告专员'
  },
  {
    value: AdminRole.ADMIN_AD_SUPER,
    text: '超级管理员'
  }
]

const businessContactStatusText = [
  {
    value: -1,
    text: '全部'
  },
  {
    value: 1,
    text: '待处理'
  },
  {
    value: 2,
    text: '已联系'
  },
  {
    value: 3,
    text: '已忽略'
  },
  {
    value: 0,
    text: '未提交'
  }
]

const enterpriseAuthStatusText = [
  {
    value: -1,
    text: '全部'
  },
  {
    value: 1,
    text: '待审核'
  },
  {
    value: 2,
    text: '已通过'
  },
  {
    value: 3,
    text: '认证失败'
  },
  {
    value: 4,
    text: '已忽略'
  },
  {
    value: 0,
    text: '未提交'
  }
]

const userProductStatusText = [
  {
    value: 0,
    // v2.10 应产品临时需求，改为 使用中，原本 '等待开启服务，ip未配置'
    text: '使用中'
  },
  {
    value: 1,
      // v2.10 应产品临时需求，改为 使用中，原本 '等待开启服务，ip已配置'
    text: '使用中'
  },
  {
    value: 2,
    text: '使用中'
  },
  {
    value: 3,
    text: '即将过期'
  },
  {
    value: 4,
    text: '已过期'
  }
]

const renewDurationText = [
  {
    value: 0,
    text: '请选择'
  },
  {
    value: 1,
    text: '1月'
  },
  {
    value: 2,
    text: '2月'
  },
  {
    value: 3,
    text: '3月'
  },
  {
    value: 4,
    text: '4月'
  },
  {
    value: 5,
    text: '5月'
  },
  {
    value: 6,
    text: '6月'
  },
  {
    value: 7,
    text: '7月'
  },
  {
    value: 8,
    text: '8月'
  },
  {
    value: 9,
    text: '9月'
  },
  {
    value: 10,
    text: '10月'
  },
  {
    value: 11,
    text: '11月'
  },
  {
    value: 12,
    text: '1年'
  },
  {
    value: 18,
    text: '1.5年'
  },
  {
    value: 24,
    text: '2年'
  },
  {
    value: 30,
    text: '2.5年'
  },
  {
    value: 36,
    text: '3年'
  }
]

const renewalDurationText = [
  {
    value: 1,
    text: '月付'
  },
  {
    value: 2,
    text: '2个月'
  },
  {
    value: 3,
    text: '季付'
  },
  {
    value: 4,
    text: '4个月'
  },
  {
    value: 5,
    text: '5个月'
  },
  {
    value: 6,
    text: '半年付'
  },
  {
    value: 7,
    text: '7个月'
  },
  {
    value: 8,
    text: '8个月'
  },
  {
    value: 9,
    text: '9个月'
  },
  {
    value: 10,
    text: '10个月'
  },
  {
    value: 11,
    text: '11个月'
  },
  {
    value: 12,
    text: '年付'
  },
  {
    value: 18,
    text: '1.5年'
  },
  {
    value: 24,
    text: '2年'
  },
  {
    value: 30,
    text: '2.5年'
  },
  {
    value: 36,
    text: '3年'
  }
]

const renewalContactText = [
  {
    value: 0,
    text: '技术'
  },
  {
    value: 1,
    text: '业务'
  },
  {
    value: 2,
    text: '财务'
  }
]

const productBuyStatusText = [
  {
    value: 3,
    text: '有效产品'
  },
  {
    value: 4,
    text: '过期产品'
  },
  {
    value: 1,
    text: '试用产品'
  },
  {
    value: 2,
    text: '试用结束'
  }
]

const visibleText = [
  {
    text: '上架',
    value: true
  },
  {
    text: '下架',
    value: false
  }
]

const userRegisterSourceText = [
  {
    value: 0,
    text: '主动注册'
  },
  {
    value: 1,
    text: '七陌客服'
  },
  {
    value: 2,
    text: '球探后台'
  },
  {
    value: 3,
    text: 'QQ'
  },
  {
    value: 4,
    text: '其他'
  }
]

const purchaseIntentionStatusText = [
  {
    value: -1,
    text: '全部'
  },
  {
    value: 0,
    text: '未提交'
  },
  {
    value: 1,
    text: '未处理'
  },
  {
    value: 2,
    text: '已处理'
  },
  {
    value: 3,
    text: '已忽略'
  }
]

const tempIntentionStatusText = purchaseIntentionStatusText.slice(0)
tempIntentionStatusText.splice(1, 1)
const intentionStatusText = tempIntentionStatusText

const userSearchTypeText = [
  {
    value: 0,
    text: '公司名称'
  },
  {
    value: 1,
    text: '用户id'
  },
  {
    value: 2,
    text: '联系人'
  },
  {
    value: 3,
    text: '电话'
  },
  {
    value: 4,
    text: 'qq'
  },
  {
    value: 5,
    text: 'ip地址'
  }
]

const queryArticleStatusTypeText = [
  {
    text: '显示状态',
    value: -1
  },
  {
    text: '公开',
    value: 0
  },
  {
    text: '隐藏',
    value: 1
  }
]

const queryNoticeStatusTypeText = [
  {
    text: '发送成功',
    value: 0
  },
  {
    text: '发送失败',
    value: 1
  },
  {
    text: '不发送',
    value: 2
  },
  {
    text: '失败重发',
    value: 3
  }
]

const GAME_TYPE = [
  { text: 'LOL', value: 1 },
  { text: 'DOTA', value: 2 },
  { text: 'CSGO', value: 3 },
  { text: 'KOG', value: 4 },
  { text: 'OW', value: 5 },
  { text: 'PUBG', value: 6 },
  { text: 'RAINBOW', value: 7 },
  { text: 'OW2', value: 8 },
  { text: 'ROCKET', value: 9 },
  { text: 'SC2', value: 10 },
  { text: 'HOS', value: 11 },
  { text: 'HS', value: 12 }

]

const GAME_TYPE_SEARCH_TEXT = [{ text: '全部', value: 0 }].concat(GAME_TYPE)

const GAME_BET_SOURCE = [
  { text: '全部', value: -1 },
  { text: 'vpgame', value: 0 },
  { text: 'uwinmax', value: 1 },
  { text: 'ourEsport', value: 2 },
  { text: 'xxdianjing', value: 3 },
  { text: 'anggame', value: 4 },
  { text: 'leihuo', value: 5 },
  { text: 'raybet', value: 6 },
  { text: 'aviagaming', value: 7 },
  { text: 'unikrn', value: 8 },
  { text: 'vk', value: 9 },
  { text: 'BET365', value: 10 }
]

const GAME_BET_STATUS = [
  { text: '全部', value: -1 },
  { text: '比赛尚未开始，竞猜开始', value: 0 },
  { text: '比赛进行中，截止竞猜', value: 1 },
  { text: '竞猜已结束', value: 2 },
  { text: '竞猜已取消', value: 3 }
]

const GAME_LOL_BET_TYPE = [
  { text: '全部', value: -1 },
  { text: '其他', value: 0 },
  { text: '全场获胜', value: 1 },
  { text: '输赢', value: 2 },
  { text: '全场让分', value: 3 },
  { text: '1血', value: 4 },
  { text: '5杀', value: 5 },
  { text: '10杀', value: 6 },
  { text: '首塔', value: 7 },
  { text: '小龙首杀', value: 8 },
  { text: '大龙首杀', value: 9 },
  { text: '人头总数奇偶', value: 10 },
  { text: '总击杀数', value: 11 },
  { text: '比赛时长', value: 12 },
  { text: '五分钟内一血', value: 13 },
  { text: '击杀数最多', value: 14 },
  { text: '第一条小龙元素', value: 15 },
  { text: '第一条小龙元素水', value: 16 },
  { text: '第一条小龙元素土', value: 17 },
  { text: '第一条小龙元素火', value: 18 },
  { text: '第一条小龙元素风', value: 19 },
  { text: '小龙总击杀单双', value: 20 },
  { text: '首杀峡谷先锋', value: 21 },
  { text: '十四分钟内是否摧毁首塔', value: 22 },
  { text: '摧塔总数大小', value: 23 },
  { text: '摧塔总数单双', value: 24 },
  { text: '首队摧毁水晶兵营', value: 25 },
  { text: '10分钟总击杀', value: 26 },
  { text: '20分钟总击杀', value: 27 },
  { text: '全场正确比分', value: 28 },
  { text: '地图总数大小', value: 29 },
  { text: '回合让分', value: 30 },
  { text: '回合击杀数', value: 31 }
]

const GAME_DOTA_BET_TYPE = [
  { text: '全部', value: -1 },
  { text: '其它', value: 0 },
  { text: '全场获胜', value: 1 },
  { text: '输赢', value: 2 },
  { text: '全场让分', value: 3 },
  { text: '1血', value: 4 },
  { text: '5杀', value: 5 },
  { text: '10杀', value: 6 },
  { text: '比赛时间大小', value: 7 },
  { text: '人头总数奇偶', value: 8 },
  { text: '首塔', value: 9 },
  { text: '首兵营', value: 10 },
  { text: '首肉山', value: 11 },
  { text: '第十五次击杀', value: 12 },
  { text: '第二十次击杀', value: 13 },
  { text: '第三十次击杀', value: 14 },
  { text: '第四十次击杀', value: 15 },
  { text: '第五十次击杀', value: 16 },
  { text: '首功能符种类', value: 17 },
  { text: '第八分钟功能神符种类', value: 18 },
  { text: '第十分钟功能神符种类', value: 19 },
  { text: '第十二分钟功能神符种类', value: 20 },
  { text: '最多赏金神符', value: 21 },
  { text: '最多功能神符', value: 22 },
  { text: '首跳刀', value: 23 },
  { text: '首黑皇杖', value: 24 },
  { text: '单局时间', value: 25 },
  { text: '10分钟总击杀大小', value: 26 },
  { text: '20分钟总击杀大小', value: 27 },
  { text: '30分钟总击杀大小', value: 28 },
  { text: '全场正确比分', value: 29 },
  { text: '全场地图总数大小', value: 30 },
  { text: '回合让分', value: 31 },
  { text: '回合击杀数', value: 32 },
  { text: '总击杀数', value: 33 }
]

const GAME_CSGO_BET_TYPE = [
  { text: '全部', value: -1 },
  { text: '其它', value: 0 },
  { text: '全场获胜', value: 1 },
  { text: '输赢', value: 2 },
  { text: '手枪局获胜', value: 3 },
  { text: '全场让分', value: 4 },
  { text: '让分', value: 5 },
  { text: '大小分', value: 6 },
  { text: '回合总数奇偶', value: 8 },
  { text: '人头总数奇偶', value: 7 },
  { text: '第四回合胜者', value: 9 },
  { text: '第六回合胜者', value: 10 },
  { text: '第八回合胜者', value: 11 },
  { text: '第十回合胜者', value: 12 },
  { text: '是否出现加时', value: 13 },
  { text: 'C4炸弹爆炸获胜次数最多（不含加时）', value: 14 },
  { text: 'C4炸弹爆炸获得胜利总数大小（不含加时）', value: 15 },
  { text: 'C4炸弹拆除次数最多队伍（不含加时）', value: 16 },
  { text: 'C4炸弹拆除总数单双（不含加时', value: 17 },
  { text: 'C4炸弹拆除总数大小（不含加时）', value: 18 },
  { text: '首赢五回合', value: 19 },
  { text: '首赢十回合', value: 20 },
  { text: '全场正确比分', value: 21 },
  { text: '地图总数大小', value: 22 }
]

const GAME_OW_BET_TYPE = [
  { text: '全部', value: -1 },
  { text: '其它', value: 0 },
  { text: '全场获胜', value: 1 },
  { text: '全场让分', value: 2 }
]

const GAME_PUBG_BET_TYPE = [
  { text: '五杀', value: -1 },
  { text: '前五', value: 0 },
  { text: '总击杀大小', value: 1 },
  { text: '总击杀最高', value: 2 }
]

const GAME_RAINBOW_BET_TYPE = [
  ...GAME_OW_BET_TYPE
]

const GAME_OW2_BET_TYPE = [
  ...GAME_OW_BET_TYPE
]

const GAME_ROCKET_BET_TYPE = [
  ...GAME_OW_BET_TYPE
]

const GAME_SC2_BET_TYPE = [
  ...GAME_OW_BET_TYPE
]

const GAME_HOS_BET_TYPE = [
  ...GAME_OW_BET_TYPE
]

const GAME_HS_BET_TYPE = [
  { text: '全部', value: -1 }
]

const GAME_KOG_BET_TYPE = [
  { text: '全部', value: -1 },
  { text: '其它', value: 0 },
  { text: '全场获胜', value: 1 },
  { text: '输赢', value: 2 },
  { text: '全场让分', value: 3 },
  { text: '5杀', value: 4 },
  { text: '10杀', value: 5 },
  { text: '单双杀数', value: 6 }
]

const GAME_RECORD_ACTION_TYPE = [
  { text: '修改', value: 0 },
  { text: '删除', value: 1 }
]

const LEAGUE_STATUS = [
  { text: '全部', value: -1 },
  { text: '未开始', value: 0 },
  { text: '进行中', value: 1 },
  { text: '已结束', value: 2 }
]

const valueMapperType = {
  text: 0,
  id: 1,
  time: 2,
  enums: 3,
  img: 4,
  link: 5
}
// 根据服务端返回的数据做的映射
const pageMapperType = {
  match: 'match',
  bet: 'bet',
  league: 'league',
  battle: 'battle',
  teamStats: 'teamStats',
  playerStats: 'playerStats',
  hero: 'hero', // 英雄
  rune: 'rune', // 附文
  skill: 'skill', // 技能
  team: 'team', // 战队/团队
  player: 'player', // 选手
  item: 'item' // 道具
}

// PBDataType -> pageMapperType
const dataType2PageType = {
  1: pageMapperType.league, // 联赛
  2: pageMapperType.match, // 比赛
  5: pageMapperType.team, // 战队
  6: pageMapperType.player, // 选手
  7: pageMapperType.hero, // 英雄
  8: pageMapperType.item, // 道具
  9: pageMapperType.skill, // 技能
  10: pageMapperType.rune, // 符文
  11: pageMapperType.bet // bet
}

// PBDataType
const dataTypeText = [
  {
    value: 2,
    text: '比赛'
  },
  {
    value: 11,
    text: '赔率'
  },
  {
    value: 1,
    text: '联赛'
  },
  {
    value: 5,
    text: '战队'
  },
  {
    value: 6,
    text: '选手'
  },
  {
    value: 7,
    text: '英雄'
  },
  {
    value: 8,
    text: '道具'
  },
  {
    value: 9,
    text: '技能'
  },
  {
    value: 10,
    text: '符文'
  }
  // {
  //   value: 3,
  //   text: '对局'
  // },
  // {
  //   value: 4,
  //   text: '即时对局'
  // },
]
const dataTypeSearchText = [{ value: 0, text: '全部' }].concat(dataTypeText)

export default function(enums, protoNested) {
  return {
    SELECT_ALL,
    SELECT_ALLN,
    GAME_RECORD_ACTION_TYPE,
    GAME_KOG_BET_TYPE,
    GAME_PUBG_BET_TYPE,
    GAME_RAINBOW_BET_TYPE,
    GAME_OW2_BET_TYPE,
    GAME_ROCKET_BET_TYPE,
    GAME_SC2_BET_TYPE,
    GAME_HOS_BET_TYPE,
    GAME_HS_BET_TYPE,
    GAME_OW_BET_TYPE,
    GAME_CSGO_BET_TYPE,
    GAME_DOTA_BET_TYPE,
    GAME_LOL_BET_TYPE,
    GAME_BET_STATUS,
    GAME_BET_SOURCE,
    GAME_TYPE,
    GAME_TYPE_SEARCH_TEXT,
    LEAGUE_STATUS,
    dataTypeText,
    dataTypeSearchText,
    valueMapperType,
    pageMapperType,
    dataType2PageType,
    userSearchTypeText,
    intentionStatusText,
    userRegisterSourceText,
    purchaseIntentionStatusText,
    productBuyStatusText,
    visibleText,
    renewDurationText,
    renewalDurationText,
    renewalContactText,
    userProductStatusText,
    enterpriseAuthStatusText,
    businessContactStatusText,
    ADMINROLE,
    queryArticleStatusTypeText,
    queryNoticeStatusTypeText,
    userCooperationStatusText: [
      {
        text: '非客户',
        value: enums.PBUserCooperationStatus.UCS_NOT_CUSTOMER
      },
      {
        text: '未合作',
        value: enums.PBUserCooperationStatus.UCS_NOT_COOPERATION
      },
      {
        text: '合作中',
        value: enums.PBUserCooperationStatus.UCS_IN_COOPERATION
      },
      {
        text: '接口过期',
        value: enums.PBUserCooperationStatus.UCS_INTERFACE_EXPIRED
      },
      {
        text: '已流失',
        value: enums.PBUserCooperationStatus.UCS_LOST
      }
    ],
    customerBusinessTypeText: [
      {
        text: '彩票',
        value: protoNested.fw.PBCustomerBusinessType.CUSTOMER_BT_LOTTERY
      },
      {
        text: '资讯',
        value: protoNested.fw.PBCustomerBusinessType.CUSTOMER_BT_INFORMATION
      },
      {
        text: '直播',
        value: protoNested.fw.PBCustomerBusinessType.CUSTOMER_BT_LIVE
      },
      {
        text: '数据',
        value: protoNested.fw.PBCustomerBusinessType.CUSTOMER_BT_DATA
      },
      {
        text: '竞猜',
        value: protoNested.fw.PBCustomerBusinessType.CUSTOMER_BT_QUIZ
      },
      {
        text: '推荐',
        value: protoNested.fw.PBCustomerBusinessType.CUSTOMER_BT_RECOMMEND
      },
      {
        text: '游戏',
        value: protoNested.fw.PBCustomerBusinessType.CUSTOMER_BT_GAME
      }
    ],
    customerProductFormTypeText: [
      {
        text: 'PC',
        value: enums.PBCustomerProductForm.CUSTOMER_PF_PC
      },
      {
        text: 'APP',
        value: enums.PBCustomerProductForm.CUSTOMER_PF_APP
      },
      {
        text: '小程序',
        value: enums.PBCustomerProductForm.CUSTOMER_PF_MINI_PROGRAM
      },
      {
        text: 'H5',
        value: enums.PBCustomerProductForm.CUSTOMER_PF_H5
      }
    ],
    customerTechLevelTypeText: [
      {
        text: '低',
        value: enums.PBCustomerTechLevel.CUSTOMER_TL_LEVEL_LOW
      },
      {
        text: '中',
        value: enums.PBCustomerTechLevel.CUSTOMER_TL_LEVEL_MEDIUM
      },
      {
        text: '高',
        value: enums.PBCustomerTechLevel.CUSTOMER_TL_LEVEL_HIGH
      }
    ],
    customerPopularityText: [
      {
        text: '低',
        value: enums.PBCustomerPopularity.CUSTOMER_POPULARITY_LOW
      },
      {
        text: '中',
        value: enums.PBCustomerPopularity.CUSTOMER_POPULARITY_MEDIUM
      },
      {
        text: '高',
        value: enums.PBCustomerPopularity.CUSTOMER_POPULARITY_HIGH
      }
    ],
    contributionDegreeText: [
      {
        text: '低',
        value: enums.PBContributionDegree.CUSTOMER_CB_DEGREE_LOW
      },
      {
        text: '中',
        value: enums.PBContributionDegree.CUSTOMER_CB_DEGREE_MEDIUM
      },
      {
        text: '高',
        value: enums.PBContributionDegree.CUSTOMER_CB_DEGREE_HIGH
      }
    ],
    invoiceTypeText: [
      {
        text: '未配置',
        value: enums.PBInvoiceType.INVOICE_TYPE_NOT_CONFIG
      },
      {
        text: '无需发票',
        value: enums.PBInvoiceType.INVOICE_TYPE_NOT_NEED
      },
      {
        text: '专票',
        value: enums.PBInvoiceType.INVOICE_TYPE_SPECIAL
      },
      {
        text: '普票(电子)',
        value: enums.PBInvoiceType.INVOICE_TYPE_ORDINARY_ELECTRONIC
      },
      {
        text: '普票(纸质)',
        value: enums.PBInvoiceType.INVOICE_TYPE_ORDINARY_PAPER
      },
      {
        text: '收据',
        value: enums.PBInvoiceType.INVOICE_TYPE_RECEIPT
      }
    ],
    billInvoiceTypeText: [
      {
        text: '未配置',
        value: enums.PBInvoiceType.INVOICE_TYPE_NOT_CONFIG
      },
      {
        text: '无需发票',
        value: enums.PBInvoiceType.INVOICE_TYPE_NOT_NEED
      },
      {
        text: '专票',
        value: enums.PBInvoiceType.INVOICE_TYPE_SPECIAL
      },
      {
        text: '增值税普通发票(电子)',
        value: enums.PBInvoiceType.INVOICE_TYPE_ORDINARY_ELECTRONIC
      },
      {
        text: '增值税普通发票(纸质)',
        value: enums.PBInvoiceType.INVOICE_TYPE_ORDINARY_PAPER
      },
      {
        text: '收据',
        value: enums.PBInvoiceType.INVOICE_TYPE_RECEIPT
      }
    ],
    openedInvoiceTypeText: [
      {
        text: '增值税专用发票',
        value: enums.PBInvoiceType.INVOICE_TYPE_SPECIAL
      },
      {
        text: '增值税普通发票(纸质)',
        value: enums.PBInvoiceType.INVOICE_TYPE_ORDINARY_PAPER
      },
      {
        text: '增值税普通发票(电子)',
        value: enums.PBInvoiceType.INVOICE_TYPE_ORDINARY_ELECTRONIC
      },
      {
        text: '收据',
        value: enums.PBInvoiceType.INVOICE_TYPE_RECEIPT
      }
    ],
    contractStatusText: [
      {
        text: '全部',
        value: -1
      },
      {
        text: '过期',
        value: enums.PBContractStatus.CONTRACT_STATUS_EXPIRED
      },
      {
        text: '即将过期',
        value: enums.PBContractStatus.CONTRACT_STATUS_TO_BE_EXPIRE
      },
      {
        text: '有效',
        value: enums.PBContractStatus.CONTRACT_STATUS_EFFECTIVE
      }
    ],
    contractTypeText: [ // 协议类型
      {
        text: '全部',
        value: -1
      },
      {
        text: '在线协议',
        value: enums.PBContractType.CT_ONLINE
      },
      {
        text: '纸质合同',
        value: enums.PBContractType.CT_PAPER
      }
    ],
    contractCirculationStatusText: [
      {
        text: '全部',
        value: -1
      },
      {
        text: '流转中',
        value: enums.PBContractCirculationStatus.CONTRACT_CS_IN_CIRCULATION
      },
      {
        text: '流转完成',
        value: enums.PBContractCirculationStatus.CONTRACT_CS_FINISH
      }
    ],
    customerSearchDateTypeText: [
      {
        text: '产品有效期限',
        value: enums.PBCustomerSearchDateType.CUSTOMER_SEARCH_DATE_PRODUCT
      },
      {
        text: '合同开始时间',
        value: enums.PBCustomerSearchDateType.CUSTOMER_SEARCH_DATE_CONTRACT_BEGIN
      },
      {
        text: '合同结束时间',
        value: enums.PBCustomerSearchDateType.CUSTOMER_SEARCH_DATE_CONTRACT_END
      }
    ],
    customerSearchKeyTypeText: [
      {
        text: '公司名称',
        value: enums.PBCustomerSearchKeyType.CUSTOMER_SEARCH_KEY_COMPANY_NAME
      },
      {
        text: '用户ID',
        value: enums.PBCustomerSearchKeyType.CUSTOMER_SEARCH_KEY_USER_ID
      }
    ],
    bussinessPurchaseIntentionStatusText: [
      {
        text: '未提交',
        value: enums.PBPurchaseIntentionStatus.PIS_UN_COMMIT
      },
      {
        text: '未处理',
        value: enums.PBPurchaseIntentionStatus.PIS_UN_PROCESS
      },
      {
        text: '已处理',
        value: enums.PBPurchaseIntentionStatus.PIS_PROCESSED
      },
      {
        text: '已忽略',
        value: enums.PBPurchaseIntentionStatus.PIS_IGNORE
      }
    ],
    serviceTypeText: [
      {
        text: '体育数据',
        value: enums.PBServiceType.SERVICE_SPORTS
      },
      {
        text: '电竞数据',
        value: enums.PBServiceType.SERVICE_ELECTRONIC_SPORTS
      }
    ],
    productTagText: [
      {
        text: '无',
        value: enums.PBProductTag.PRODUCT_TAG_NONE
      },
      {
        text: 'NEW',
        value: enums.PBProductTag.PRODUCT_TAG_NEW
      },
      {
        text: 'HOT',
        value: enums.PBProductTag.PRODUCT_TAG_HOT
      }
    ],
    transferWayText: [
      {
        text: '体育转账方式',
        value: enums.PBServiceType.SERVICE_SPORTS
      },
      {
        text: '电竞转账方式',
        value: enums.PBServiceType.SERVICE_ELECTRONIC_SPORTS
      }
    ],
    billTransferTypeText: [
      {
        text: '对公转账',
        value: enums.PBTransferType.TRANSFER_TYPE_PUBLIC
      },
      {
        text: '对私转账',
        value: enums.PBTransferType.TRANSFER_TYPE_PRIVATE
      }
    ],
    historyTrialProductTypeText: [
      {
        text: '全部',
        value: ''
      },
      {
        text: '未试用',
        value: '-1'
      },
      {
        text: '足球',
        value: protoNested.fw.PBProductType.PT_FOOTBALL.toString()
      },
      {
        text: '篮球',
        value: protoNested.fw.PBProductType.PT_BASKETBALL.toString()
      },
      {
        text: '网球',
        value: protoNested.fw.PBProductType.PT_TENNIS.toString()
      },
      {
        text: '美式足球',
        value: protoNested.fw.PBProductType.PT_AMERICAN_FOOTBALL.toString()
      },
      {
        text: '电竞',
        value: protoNested.fw.PBProductType.PT_EG_SPORTS.toString()
      }
    ],
    // 产品购买状态
    PRODUCT_BUY_STATUS: [
      {
        text: '未购买',
        value: enums.PBProductBuyStatus.PPS_UN_BUY
      },
      {
        text: '试用中',
        value: enums.PBProductBuyStatus.PPS_IN_TRIAL
      },
      {
        text: '试用结束',
        value: enums.PBProductBuyStatus.PPS_TRIAL_END
      },
      {
        text: '已购买',
        value: enums.PBProductBuyStatus.PPS_PURCHASE
      },
      {
        text: '历史购买',
        value: enums.PBProductBuyStatus.PPS_HISTORY_BUY
      }
    ],
    contactDutyTypeText: [
      {
        text: '业务',
        value: enums.PBContactDuty.CONTACT_DUTY_BUSINESS
      },
      {
        text: '技术',
        value: enums.PBContactDuty.CONTACT_DUTY_TECHNIQUE
      },
      {
        text: '财务',
        value: enums.PBContactDuty.CONTACT_DUTY_FINANCE
      }
    ],
    userLogCategoryText: [
      {
        text: '需求',
        value: enums.PBUserLogCategory.ULC_DEMAND
      },
      {
        text: '问题',
        value: enums.PBUserLogCategory.ULC_PROBLEM
      },
      {
        text: '其他',
        value: enums.PBUserLogCategory.ULC_OTHER
      }
    ],
    financeSortTypeText: [
      {
        text: '按产品有效期限',
        value: enums.PBFinanceSortType.FINANCE_SORT_EFFECTIVE_DATE
      },
      {
        text: '按到帐日期',
        value: enums.PBFinanceSortType.FINANCE_SORT_ARRIVE_DATE
      },
      {
        text: '按合同期限',
        value: enums.PBFinanceSortType.FINANCE_SORT_CONTRACT_DATE
      }
    ],
    financeTypeText: [
      {
        text: '新客新增',
        value: enums.PBFinanceType.FINANCE_TYPE_NEW_INCREASE
      },
      {
        text: '老客新增',
        value: enums.PBFinanceType.FINANCE_TYPE_OLD_INCREASE
      },
      {
        text: '续费',
        value: enums.PBFinanceType.FINANCE_TYPE_RENEWAL
      }
    ],
    arriveStatusText: [
      {
        text: '未到帐',
        value: enums.PBArriveStatus.ARRIVE_STATUS_NOT_ARRIVED
      },
      {
        text: '已到帐',
        value: enums.PBArriveStatus.ARRIVE_STATUS_ARRIVED
      },
      {
        text: '已流失',
        value: enums.PBArriveStatus.ARRIVE_STATUS_LOST
      }
    ],
    userLogSearchCategoryText: [
      {
        text: '全部',
        value: -1
      },
      {
        text: '需求',
        value: enums.PBUserLogCategory.ULC_DEMAND
      },
      {
        text: '问题',
        value: enums.PBUserLogCategory.ULC_PROBLEM
      },
      {
        text: '通知',
        value: enums.PBUserLogCategory.ULC_SYSTEM_INFO
      }
    ],
    orderTypeText: [
      {
        text: '升序',
        value: enums.PBOrderType.OTP_ASC
      },
      {
        text: '降序',
        value: enums.PBOrderType.OTP_DESC
      }
    ],
    renewalStatusText: [
      {
        text: '待审核',
        value: enums.PBRenewalStatus.RENEWAL_STATUS_PENDING
      },
      {
        text: '续费失败',
        value: enums.PBRenewalStatus.RENEWAL_STATUS_FAIL
      },
      {
        text: '续费成功',
        value: enums.PBRenewalStatus.RENEWAL_STATUS_SUCCESS
      },
      {
        text: '待续费',
        value: enums.PBRenewalStatus.RENEWAL_STATUS_TO_BE
      }
    ],
    extraStatusesTypeText: [
      {
        text: '提前续费',
        value: enums.PBRenewalExtraStatus.RENEW_ADVANCE
      },
      {
        text: '延期续费',
        value: enums.PBRenewalExtraStatus.RENEW_DELAY
      },
      {
        text: '其他变更',
        value: enums.PBRenewalExtraStatus.RENEW_CHANGE
      },
      {
        text: '预流失',
        value: enums.PBRenewalExtraStatus.RENEW_PRE_LOST
      },
      {
        text: '部分流失',
        value: enums.PBRenewalExtraStatus.RENEW_PART_LOST
      },
      {
        text: '频次变更',
        value: enums.PBRenewalExtraStatus.RENEW_NUM_CHANGE
      }
    ],
    renewalFailTypeText: [
      {
        text: '汇款凭证不正确',
        value: enums.PBRenewalFailType.RENEWAL_FAIL_VOUCHER_ERROR
      },
      {
        text: '逾期未续费',
        value: enums.PBRenewalFailType.RENEWAL_FAIL_EXPIRED
      },
      {
        text: '客户已流失',
        value: enums.PBRenewalFailType.RENEWAL_FAIL_LOST
      },
      {
        text: '不再续费',
        value: enums.PBRenewalFailType.RENEWAL_NOT
      },
      {
        text: '其他',
        value: enums.PBRenewalFailType.RENEWAL_OTHER
      }
    ],
    billInfoStatusText: [
      {
        text: '待审核',
        value: enums.PBBillInfoStatus.BILL_INFO_PENDING
      },
      {
        text: '驳回',
        value: enums.PBBillInfoStatus.BILL_INFO_REJECT
      },
      {
        text: '通过',
        value: enums.PBBillInfoStatus.BILL_INFO_PASS
      },
      {
        text: '忽略',
        value: enums.PBBillInfoStatus.BILL_INFO_IGNORE
      }
    ],
    billInfoStatusOptionText: [
      {
        text: '待审核',
        value: enums.PBBillInfoStatus.BILL_INFO_PENDING
      },
      {
        text: '通过（通知客户）',
        value: enums.PBBillInfoStatus.BILL_INFO_PASS
      },
      {
        text: '驳回（通知客户）',
        value: enums.PBBillInfoStatus.BILL_INFO_REJECT
      },
      {
        text: '忽略',
        value: enums.PBBillInfoStatus.BILL_INFO_IGNORE
      }
    ],
    billInfoStatusIgnoreOptionText: [
      {
        text: '忽略',
        value: enums.PBBillInfoStatus.BILL_INFO_IGNORE
      },
      {
        text: '待审核',
        value: enums.PBBillInfoStatus.BILL_INFO_PENDING
      }
    ],
    invoiceStatusText: [
      {
        text: '待审核',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_PENDING
      },
      {
        text: '商务跟进',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_BUSINESS_FOLLOW
      },
      {
        text: '预申请',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_PRE_APPLY
      },
      {
        text: '待开票',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_TO_OPEN
      },
      {
        text: '已开票',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_OPENED
      },
      {
        text: '驳回申请',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_REJECT
      },
      {
        text: '已寄送',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_SENT
      },
      {
        text: '已签收',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_SIGNED
      }
    ],
    invoiceStatusTabs: [
      {
        text: '待审核',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_PENDING
      },
      {
        text: '商务跟进',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_BUSINESS_FOLLOW
      },
      {
        text: '预申请',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_PRE_APPLY
      },
      {
        text: '待开票',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_TO_OPEN
      },
      {
        text: '已开票',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_OPENED
      },
      {
        text: '驳回申请',
        value: enums.PBInvoiceStatus.INVOICE_STATUS_REJECT
      }
    ],
    invoicePendingTypeText: [
      {
        text: '业务审核',
        value: enums.PBInvoicePendingType.INVOICE_PENDING_BUSINESS
      },
      {
        text: '主管审核',
        value: enums.PBInvoicePendingType.INVOICE_PENDING_DIRECTOR
      },
      {
        text: '财务审核',
        value: enums.PBInvoicePendingType.INVOICE_PENDING_FINANCE
      }
    ],
    invoicePendingDealTypeText: [
      {
        text: '待处理',
        value: enums.PBInvoiceDealType.INVOICE_DEAL_NONE
      },
      {
        text: '同意开票',
        value: enums.PBInvoiceDealType.INVOICE_DEAL_AGREE
      },
      {
        text: '信息有误，转商务跟进',
        value: enums.PBInvoiceDealType.INVOICE_DEAL_TURN_BD
      }
    ],
    invoiceBusinessDealTypeText: [
      {
        text: '待处理',
        value: enums.PBInvoiceDealType.INVOICE_DEAL_NONE
      },
      {
        text: '重新申请开票',
        value: enums.PBInvoiceDealType.INVOICE_DEAL_REAPPLY
      },
      {
        text: '驳回开票申请',
        value: enums.PBInvoiceDealType.INVOICE_DEAL_REJECT
      }
    ],
    renewalSearchDateTypeText: [
      {
        text: '到账时间',
        value: enums.PBRenewalSearchDateType.RENEWAL_SEARCH_DATE_ARRIVE
      },
      {
        text: '提交时间',
        value: enums.PBRenewalSearchDateType.RENEWAL_SEARCH_DATE_VOUCHER
      },
      {
        text: '审核时间',
        value: enums.PBRenewalSearchDateType.RENEWAL_SEARCH_DATE_REVIEW
      },
      {
        text: '续费前有效期',
        value: enums.PBRenewalSearchDateType.RENEWAL_SEARCH_DATE_EFFECTIVE_BEFORE
      },
      {
        text: '续费后有效期',
        value: enums.PBRenewalSearchDateType.RENEWAL_SEARCH_DATE_EFFECTIVE_AFTER
      }
    ],
    deliveryStatusText: [
      {
        text: '未填写物流',
        value: enums.PBDeliveryStatus.DELIVERY_STATUS_NULL
      },
      {
        text: '已寄送',
        value: enums.PBDeliveryStatus.DELIVERY_STATUS_SENT
      },
      {
        text: '已签收',
        value: enums.PBDeliveryStatus.DELIVERY_STATUS_SIGNED
      }
    ],
    deliveryCompanyText: [
      {
        text: '顺丰',
        value: enums.PBDeliveryCompanyType.DELIVERT_COMPANY_SF
      }
    ],
    lotteryInterfaceTypeText: [
      {
        text: '全部',
        value: enums.PBInterfaceType.IT_DEFAULT
      },
      {
        text: '全国彩接口',
        value: enums.PBInterfaceType.IT_NATIONWIDE_LOTTERY
      },
      {
        text: '地方彩接口',
        value: enums.PBInterfaceType.IT_DISTRICT_LOTTERY
      },
      {
        text: '高频彩接口',
        value: enums.PBInterfaceType.IT_HIGH_FREQUENCY_LOTTERY
      },
      {
        text: '足彩接口',
        value: enums.PBInterfaceType.IT_FOOTBALL_LOTTERY
      },
      {
        text: '体育比分指数接口',
        value: enums.PBInterfaceType.IT_SCORE_LOTTERY
      }
    ],
    queryProductKeyTypeText: [
      {
        text: '接口名称',
        value: enums.PBQueryProductKeyType.QPKT_INTERFACE_NAME
      },
      {
        text: '接口编号',
        value: enums.PBQueryProductKeyType.QPKT_LOTTERY_TYPE
      }
    ],
    platFormTypeText: [
      {
        text: '注册平台',
        value: -1
      },
      {
        text: '飞鲸数据',
        value: enums.PBPlatformType.PLATFORM_TYPE_FLYWHALE
      },
      {
        text: '缤果数据',
        value: enums.PBPlatformType.PLATFORM_TYPE_LOTTERY
      }
    ],
    platFormTypeShowText: [
      {
        text: '飞鲸',
        value: enums.PBPlatformType.PLATFORM_TYPE_FLYWHALE
      },
      {
        text: '缤果',
        value: enums.PBPlatformType.PLATFORM_TYPE_LOTTERY
      }
    ],
    queryIsCustomerTypeText: [
      {
        text: '全部客户',
        value: enums.PBBoolValue.BOOL_NONE
      },
      {
        text: '是客户',
        value: enums.PBBoolValue.BOOL_TRUE
      },
      {
        text: '非客户',
        value: enums.PBBoolValue.BOOL_FALSE
      }
    ],
    lotteryOrganizationTypeText: [
      {
        text: '机构',
        value: enums.PBLotteryOrganization.LO_DEFAULT
      },
      {
        text: '福彩',
        value: enums.PBLotteryOrganization.LO_CHINA_WELFARE_LOTTERY
      },
      {
        text: '体彩',
        value: enums.PBLotteryOrganization.LO_CHINA_SPORTS_LOTTERY
      },
      {
        text: '其他',
        value: enums.PBLotteryOrganization.LO_OTHER
      }
    ],
    lotteryOrderPayStatusTypeText: [
      {
        text: '待支付',
        value: enums.PBOrderPayStatus.OPS_PENDING
      },
      {
        text: '已支付',
        value: enums.PBOrderPayStatus.OPS_PAID
      },
      {
        text: '已关闭',
        value: enums.PBOrderPayStatus.OPS_CLOSE
      }
    ],
    lotteryOrderPayTypeText: [
      {
        text: '免费试用',
        value: enums.PBOrderPayType.OPT_FREE
      },
      {
        text: '微信支付',
        value: enums.PBOrderPayType.OPT_WECHAT_NATIVE
      },
      {
        text: '支付宝支付',
        value: enums.PBOrderPayType.OPT_ALIPAY_WEB
      },
      {
        text: '快钱支付',
        value: enums.PBOrderPayType.OPT_99BILL
      },
      {
        text: '线下支付',
        value: enums.PBOrderPayType.OPT_BANK
      }
    ],
    lotteryBillStatusTypeText: [
      {
        text: '未开票',
        value: enums.PBBillStatus.BS_UNBILLED
      },
      {
        text: '已开票',
        value: enums.PBBillStatus.BS_BILLED
      }
    ],
    lotteryQueryOrderKeyTypeText: [
      {
        text: '订单号',
        value: enums.PBQueryOrderKeyType.QOKT_ORDER_ID
      },
      {
        text: '客户手机号',
        value: enums.PBQueryOrderKeyType.QOKT_CUSTOM_MOBILE
      },
      {
        text: '客户ID',
        value: enums.PBQueryOrderKeyType.QOKT_CUSTOM_ID
      },
      {
        text: '客户名称',
        value: enums.PBQueryOrderKeyType.QOKT_CUSTOM_NAME
      },
      {
        text: '交易流水号',
        value: enums.PBQueryOrderKeyType.QOKT_PAY_ID
      }
    ],
    lotteryUserCooperationStatusText: [
      {
        text: '未合作',
        value: enums.PBBgCustomerCooperationStatus.CCS_NOT_CUSTOMER
      },
      {
        text: '试用中',
        value: enums.PBBgCustomerCooperationStatus.CCS_IN_TRIAL
      },
      {
        text: '未合作',
        value: enums.PBBgCustomerCooperationStatus.CCS_NOT_COOPERATION
      },
      {
        text: '合作中',
        value: enums.PBBgCustomerCooperationStatus.CCS_IN_COOPERATION
      },
      {
        text: '接口过期',
        value: enums.PBBgCustomerCooperationStatus.CCS_INTERFACE_EXPIRED
      }
    ],
    lotteryQueryOrderDateTypeText: [
      {
        text: '支付时间',
        value: enums.PBQueryOrderDateType.QODT_PAY_DATE
      },
      {
        text: '创建时间',
        value: enums.PBQueryOrderDateType.QODT_CREATE_DATE
      }
    ],
    lotteryCustomerSearchKeyTypeText: [
      {
        text: '客户ID',
        value: enums.PBCustomerQueryKeyType.CSK_CUSTOMER_ID
      },
      {
        text: '客户名称',
        value: enums.PBCustomerQueryKeyType.CSK_CUSTOMER_NAME
      },
      {
        text: '用户ID',
        value: enums.PBCustomerQueryKeyType.CSK_USER_ID
      },
      {
        text: '绑定手机',
        value: enums.PBCustomerQueryKeyType.CSK_MOBILE
      },
      {
        text: '绑定邮箱',
        value: enums.PBCustomerQueryKeyType.CSK_EMAIL
      },
      {
        text: '已购接口名称',
        value: enums.PBCustomerQueryKeyType.CSK_BOUGHT_INTERFACE_NAME
      },
      {
        text: '已购接口ID',
        value: enums.PBCustomerQueryKeyType.CSK_BOUGHT_INTERFACE_ID
      }
    ],
    lotteryCustomerSearchDateTypeText: [
      {
        text: '接口有效期',
        value: enums.PBCustomerQueryDateType.CSDT_INTERFACE_EFFECTIVE_DATE
      },
      {
        text: '初次合作日期',
        value: enums.PBCustomerQueryDateType.CSDT_INITIALCPDATE
      },
      {
        text: '初次试用时间',
        value: enums.PBCustomerQueryDateType.CSDT_INITIAL_TRY_DATE
      }
    ],
    lotteryProductStatusTypeText: [
      {
        text: '上架',
        value: enums.PBProductStatus.PS_ENABLE
      },
      {
        text: '下架',
        value: enums.PBProductStatus.PS_DISABLE
      }
    ],
    lotteryProductHotStatusTypeText: [
      {
        text: '是',
        value: enums.PBProductHotStatus.PHS_HOT
      },
      {
        text: '否',
        value: enums.PBProductHotStatus.PHS_NORMAL
      }
    ],
    lotteryCustomerContributionText: [
      {
        text: '低',
        value: enums.PBBgCustomerContribution.CC_LOW
      },
      {
        text: '中',
        value: enums.PBBgCustomerContribution.CC_MEDIUM
      },
      {
        text: '高',
        value: enums.PBBgCustomerContribution.CC_HIGH
      }
    ],
    lotteryCustomerTechLevelText: [
      {
        text: '低',
        value: enums.PBBgCustomerTechLevel.CTL_LOW
      },
      {
        text: '中',
        value: enums.PBBgCustomerTechLevel.CTL_MEDIUM
      },
      {
        text: '高',
        value: enums.PBBgCustomerTechLevel.CTL_HIGH
      }
    ],
    lotteryCustomerPopularityText: [
      {
        text: '低',
        value: enums.PBBgCustomerPopularity.CP_LOW
      },
      {
        text: '中',
        value: enums.PBBgCustomerPopularity.CP_MEDIUM
      },
      {
        text: '高',
        value: enums.PBBgCustomerPopularity.CP_HIGH
      }
    ],
    lotteryCustomerProductFormText: [
      {
        text: 'PC',
        value: enums.PBBgCustomerProductForm.CPF_PC
      },
      {
        text: 'APP',
        value: enums.PBBgCustomerProductForm.CPF_APP
      },
      {
        text: '小程序',
        value: enums.PBBgCustomerProductForm.CPF_MINI_PROGRAM
      },
      {
        text: 'H5',
        value: enums.PBBgCustomerProductForm.CPF_H5
      }
    ],
    lotteryCustomerBusinessTypeText: [
      {
        text: '彩票',
        value: enums.PBBgCustomerBusinessType.CBT_LOTTERY
      },
      {
        text: '资讯',
        value: enums.PBBgCustomerBusinessType.CBT_INFORMATION
      },
      {
        text: '直播',
        value: enums.PBBgCustomerBusinessType.CBT_LIVE
      },
      {
        text: '推荐',
        value: enums.PBBgCustomerBusinessType.CBT_RECOMMEND
      },
      {
        text: '数据',
        value: enums.PBBgCustomerBusinessType.CBT_DATA
      },
      {
        text: '竞猜',
        value: enums.PBBgCustomerBusinessType.CBT_QUIZ
      },
      {
        text: '游戏',
        value: enums.PBBgCustomerBusinessType.CBT_GAME
      }
    ],
    reequestFrequencyText: [
      {
        text: '每分钟',
        value: enums.PBRequestFrequency.FREQUENCY_MINUTE
      },
      {
        text: '每秒钟',
        value: enums.PBRequestFrequency.FREQUENCY_SECOND
      },
      {
        text: '每小时',
        value: enums.PBRequestFrequency.FREQUENCY_HOUR
      },
      {
        text: '每天',
        value: enums.PBRequestFrequency.FREQUENCY_DAY
      }
    ],
    lotteryCallStatisticSearchKeyTypeText: [
      {
        text: '客户ID',
        value: protoNested.lottery.PBUserCallStatisticSearchKeyType.UCSSKT_CUSTOMER_ID
      },
      {
        text: '用户ID',
        value: protoNested.lottery.PBUserCallStatisticSearchKeyType.UCSSKT_USER_ID
      },
      {
        text: 'token',
        value: protoNested.lottery.PBUserCallStatisticSearchKeyType.UCSSKT_TOKEN
      },
      {
        text: '手机号码',
        value: protoNested.lottery.PBUserCallStatisticSearchKeyType.UCSSKT_MOBILE
      }
    ],
    filterTestTypeText: [
      {
        text: '过滤测试数据',
        value: enums.PBSearchUserType.SEARCH_REAL
      },
      {
        text: '不过滤测试数据',
        value: enums.PBSearchUserType.SEARCH_ALL
      },
      {
        text: '只看测试数据',
        value: enums.PBSearchUserType.SEARCH_TEST
      }
    ],
    noticeTypeText: [
      {
        text: '短信',
        value: enums.PBNoticeType.NOTICE_TYPE_SMS
      },
      {
        text: '邮件',
        value: enums.PBNoticeType.NOTICE_TYPE_EMAIL
      }
    ],
    noticeStatusText: [
      {
        text: '发送成功',
        value: enums.PBNoticeStatus.NOTICE_STATUS_SUCCESS
      },
      {
        text: '发送失败',
        value: enums.PBNoticeStatus.NOTICE_STATUS_SUCCESS
      },
      {
        text: '不发送',
        value: enums.PBNoticeStatus.NOTICE_STATUS_SUCCESS
      },
      {
        text: '失败重发',
        value: enums.PBNoticeStatus.NOTICE_STATUS_SUCCESS
      }
    ],
    trafficSearchTypeText: [
      {
        text: '客户名称',
        value: enums.PBTrafficSearchType.TRAFFIC_SEARCH_CUSTOMER_NAME
      },
      {
        text: '用户ID',
        value: enums.PBTrafficSearchType.TRAFFIC_SEARCH_USER_ID
      },
      {
        text: '客户ID',
        value: enums.PBTrafficSearchType.TRAFFIC_SEARCH_CUSTOMER_ID
      },
      {
        text: '绑定的手机号',
        value: enums.PBTrafficSearchType.TRAFFIC_SEARCH_MOBILE
      },
      {
        text: '绑定的邮箱',
        value: enums.PBTrafficSearchType.TRAFFIC_SEARCH_EMAIL
      }
    ],
    financeStatisticsDateType: [
      {
        text: '按日统计',
        value: enums.PBFinanceStatisticsDateType.FINANCE_STATISTICS_DAY
      },
      {
        text: '按周统计',
        value: enums.PBFinanceStatisticsDateType.FINANCE_STATISTICS_WEEK
      },
      {
        text: '按月统计',
        value: enums.PBFinanceStatisticsDateType.FINANCE_STATISTICS_MONTH
      }
    ],
    refereUrlType: [
      {
        text: '全部来源',
        value: ''
      },
      {
        text: '直接访问',
        value: '直接访问'
      },
      {
        text: 'win007.com',
        value: 'win007.com'
      },
      {
        text: 'baidu.com',
        value: 'baidu.com'
      },
      {
        text: '310win.com',
        value: '310win.com'
      },
      {
        text: 'igame007.com',
        value: 'igame007.com'
      },
      {
        text: 'iwintv.com',
        value: 'iwintv.com'
      },
      {
        text: 'google.com',
        value: 'google.com'
      }
    ],
    matchStatus: [
      {
        text: '全部',
        value: -1
      },
      {
        text: '未开始',
        value: enums.PBMatchStatus.MS_WAIT
      },
      {
        text: '进行中',
        value: enums.PBMatchStatus.MS_START
      },
      {
        text: '已结束',
        value: enums.PBMatchStatus.MS_END
      },
      {
        text: '已延时',
        value: enums.PBMatchStatus.MS_DELAY
      },
      {
        text: '已删除',
        value: enums.PBMatchStatus.MS_DELETE
      }
    ],
    dataStatus: [
      { text: '正常', value: enums.PBDataStatus.NORMAL },
      { text: '异常', value: enums.PBDataStatus.ABNORMAL },
      { text: '废弃', value: enums.PBDataStatus.TRASH },
      { text: '映射失败', value: enums.PBDataStatus.MAPPING_FAILED },
      { text: '合并失败', value: enums.PBDataStatus.MERGE_FAILED }
    ],
    abnormalSearchDateText: [
      {
        value: enums.PBQueryFailureRecordDateType.QFRDT_CREATE_DATE,
        text: '告警时间'
      },
      {
        value: enums.PBQueryFailureRecordDateType.QFRDT_MODIFY_DATE,
        text: '更新时间'
      }
    ],
    failureRecordStatusSelectText: [
      {
        value: enums.PBFailureRecordStatus.FRS_TBD,
        text: '待处理'
      },
      {
        value: enums.PBFailureRecordStatus.FRS_FIXED,
        text: '已处理'
      },
      {
        value: enums.PBFailureRecordStatus.FRS_IGNORE,
        text: '已忽略'
      },
      {
        value: enums.PBFailureRecordStatus.FRS_LATER_PROCESS,
        text: '稍后处理'
      }
    ],
    dataSourceText: [
      {
        value: enums.PBDataSource.VPGAME,
        text: 'vpgame'
      },
      {
        value: enums.PBDataSource.HLTV,
        text: 'hltv'
      },
      {
        value: enums.PBDataSource.FAMULEI,
        text: 'famulei'
      },
      {
        value: enums.PBDataSource.OURESPORTS,
        text: 'ouresports'
      },
      {
        value: enums.PBDataSource.DS_U_WIN_MAX,
        text: 'uwin'
      },
      {
        value: enums.PBDataSource.DS_XX_DIAN_JING,
        text: 'xxdianjing'
      },
      {
        value: enums.PBDataSource.DS_ANG_GAME,
        text: 'anggame'
      },
      {
        value: enums.PBDataSource.DS_LEIHUO,
        text: '雷火'
      },
      {
        value: enums.PBDataSource.DS_RAYBET,
        text: 'raybet'
      },
      {
        value: enums.PBDataSource.DS_AVIAGAMING,
        text: 'aviagaming'
      },
      {
        value: enums.PBDataSource.DS_UNIKRN,
        text: 'unikrn'
      },
      {
        value: enums.PBDataSource.DS_PANDA_SCORE,
        text: 'pandascore'
      },
      {
        value: enums.PBDataSource.DS_T2_SCORE,
        text: 't2score'
      },
      {
        value: enums.PBDataSource.DS_PUBG_8X,
        text: 'pubg8x'
      },
      {
        value: enums.PBDataSource.DS_VK,
        text: 'vk'
      },
      {
        value: enums.PBDataSource.DS_HUPU,
        text: 'hupu'
      },
      {
        value: enums.PBDataSource.DS_BET365,
        text: 'BET365'
      },
      {
        value: enums.PBDataSource.DS_ESPORTS8,
        text: 'esports8'
      }
    ],
    mappingKeysNameSearchText: [
      {
        value: 'nameKey',
        text: '名称'
      },
      {
        value: 'systemId',
        text: '系统 ID'
      },
      {
        value: 'recordId',
        text: '规则 ID'
      }
    ],
    mappingKeysIdSearchText: [
      {
        value: 'sourceId',
        text: '爬虫 ID'
      },
      {
        value: 'systemId',
        text: '系统 ID'
      },
      {
        value: 'recordId',
        text: '规则 ID'
      }
    ],
    mappingStatusSearchText: [
      {
        value: enums.PBMappingStatus.MS_DEFAULT,
        text: '全部'
      },
      {
        value: enums.PBMappingStatus.MS_ENABLE,
        text: '已启用'
      },
      {
        value: enums.PBMappingStatus.MS_DISABLE,
        text: '已禁用'
      }
    ],
    mappingStatusText: [
      {
        value: enums.PBMappingStatus.MS_ENABLE,
        text: '已启用'
      },
      {
        value: enums.PBMappingStatus.MS_DISABLE,
        text: '已禁用'
      }
    ],
    mappingTypeText: [
      {
        value: enums.PBMappingType.MT_DEFAULT,
        text: '全部'
      },
      {
        value: enums.PBMappingType.MT_FAILURE_RECORD_ADD,
        text: '异常任务'
      },
      {
        value: enums.PBMappingType.MS_ADMIN_ADD,
        text: '手动添加'
      }
    ],
    manualRecordTypeText: [
      {
        value: enums.PBManualRecordType.MRT_SYSTEM,
        text: '自动操作'
      },
      {
        value: enums.PBManualRecordType.MRT_ADMIN,
        text: '人工操作'
      }
    ],
    LEAGUE_USE_TYPE: [
      // {
      //   value: enums.PBLeagueSourceUseType.LSUT_NOT_USE,
      //   text: '不使用'
      // },
      {
        value: enums.PBLeagueSourceUseType.LSUT_USE_DEFAULT,
        text: '通用'
      },
      {
        value: enums.PBLeagueSourceUseType.LSUT_USE_SCORE,
        text: '比分更新'
      },
      {
        value: enums.PBLeagueSourceUseType.LSUT_USE_SCORE_DETAIL,
        text: '比赛详情'
      },
      {
        value: enums.PBLeagueSourceUseType.LSUT_USE_STATISTIC,
        text: '统计数据'
      },
      {
        value: enums.PBLeagueSourceUseType.LSUT_USE_PROSPECT,
        text: '前瞻数据'
      },
      {
        value: enums.PBLeagueSourceUseType.LSUT_USE_LEAGUE_TEAM_STATS,
        text: '联赛队伍统计'
      },
      {
        value: enums.PBLeagueSourceUseType.LSUT_USE_LEAGUE_PLAYER_STATS,
        text: '联赛队员统计'
      },
      {
        value: enums.PBLeagueSourceUseType.LSUT_USE_LEAGUE_HERO_STATS,
        text: '联赛英雄统计'
      },
      {
        value: enums.PBLeagueSourceUseType.LSUT_USE_LEAGUE_BOARD,
        text: '联赛积分榜'
      }
    ],
    FAILURE_PROCESS_TYPE: [
      {
        value: enums.PBFailureProcessType.FPT_ALL,
        text: '全部'
      },
      {
        value: enums.PBFailureProcessType.FPT_MATCH,
        text: '匹配数据'
      },
      {
        value: enums.PBFailureProcessType.FPT_NEW,
        text: '新建数据'
      }
    ],
    REASON_OF_DELAY_HANDLE_TYPE: [
      {
        value: '全部',
        text: '全部'
      },
      {
        value: '未知',
        text: '未知'
      },
      {
        value: '暂无赛程',
        text: '暂无赛程'
      }
    ],
    API_RETURN_PARAM_TYPE: [
      {
        value: enums.PBReturnParamType.RPT_JSON,
        text: 'JSON'
      },
      {
        value: enums.PBReturnParamType.RPT_XML,
        text: 'XML'
      },
      {
        value: enums.PBReturnParamType.RPT_CUSTOMIZE,
        text: '自定义'
      },
      {
        value: enums.PBReturnParamType.RPT_PDF,
        text: 'PDF'
      }
    ],
    LEAGUE_SOURCE_STATUS: [
      {
        value: enums.PBSpiderSourceStatus.ESS_DEFAULT,
        text: '默认'
      },
      {
        value: enums.PBSpiderSourceStatus.ESS_ENABLE,
        text: '启用'
      },
      {
        value: enums.PBSpiderSourceStatus.ESS_DISABLE,
        text: '禁用'
      }
    ],
    LEAGUE_SOURCE_SEARCH_TYPES: [
      {
        text: '联赛名称',
        value: 'leagueName'
      },
      {
        text: '联赛ID',
        value: 'leagueSystemId'
      },
      {
        text: '爬虫源名称',
        value: 'spiderName'
      }
    ],
    LIVE_LIST_TIME_TYPE: [
      {
        value: enums.PBLiveMatchSearchTimeType.MLT_ENABLE_DATE,
        text: '启用时间'
      },
      {
        value: enums.PBLiveMatchSearchTimeType.MLT_MATCH_DATE,
        text: '开赛时间'
      }
    ],
    LIVE_LIST_KEY_TYPE: [
      {
        value: enums.PBLiveMatchSearchKeyType.MLK_LIVE_ID,
        text: '直播ID'
      },
      {
        value: enums.PBLiveMatchSearchKeyType.MLT_MATCH_ID,
        text: '比赛ID'
      },
      {
        value: enums.PBLiveMatchSearchKeyType.MLT_SOURCE_ID,
        text: '直播源ID'
      },
      {
        value: enums.PBLiveMatchSearchKeyType.MLK_TEAM_NAME,
        text: '队伍名称'
      }
    ],
    LIVE_LIST_SOURCE_TYPE: [
      {
        value: enums.PBLiveSourceType.LST_DEFAULT,
        text: '全部'
      },
      {
        value: enums.PBLiveSourceType.LST_SPIDER,
        text: '爬虫源'
      },
      {
        value: enums.PBLiveSourceType.LST_ADMIN,
        text: '后台添加'
      },
      {
        value: enums.PBLiveSourceType.LST_PARTNER,
        text: '合作方添加'
      }
    ],
    LIVE_LIST_STATUS: [
      {
        value: enums.PBBoolValue.BOOL_NONE,
        text: '全部'
      },
      {
        value: enums.PBBoolValue.BOOL_TRUE,
        text: '启用'
      },
      {
        value: enums.PBBoolValue.BOOL_FALSE,
        text: '禁用'
      }
    ],
    LIVE_DETAIL_TIME_TYPE: [
      {
        value: enums.PBLiveMatchStatsSearchTimeType.MST_STATS_DATE,
        text: '统计时间'
      },
      {
        value: enums.PBLiveMatchStatsSearchTimeType.MST_CREATE_DATE,
        text: '创建时间'
      }
    ],
    LIVE_DETAIL_KEY_TYPE: [
      {
        value: enums.PBLiveMatchStatsSearchKeyType.MSK_CUSTOMER_ID,
        text: '客户ID'
      },
      {
        value: enums.PBLiveMatchStatsSearchKeyType.MST_CUSTOMER_NAME,
        text: '客户名称'
      }
    ],
    LIVE_DETAIL_COOPERATION_STATUS: [
      {
        text: '全部',
        value: -1
      },
      {
        text: '未合作',
        value: 1
      },
      {
        text: '合作中',
        value: 2
      },
      {
        text: '接口过期',
        value: 3
      },
      {
        text: '已流失',
        value: 4
      }
    ],
    LIVE_SOURCE_KEY_TYPE: [
      {
        value: 0,
        text: '合作方'
      },
      {
        value: 1,
        text: '显示名称'
      },
      {
        value: 2,
        text: '直播源ID'
      }
    ],
    LIVE_SOURCE_TYPE: [
      {
        value: enums.PBVideoType.VT_DEFAULT,
        text: '全部'
      },
      {
        value: enums.PBVideoType.VT_OUTER_CHAIN,
        text: '外链'
      },
      {
        value: enums.PBVideoType.VT_VIDEO_SOURCE,
        text: '视频源'
      },
      {
        value: enums.PBVideoType.VT_PULL_SOURCE,
        text: '直播流'
      }
    ],
    LIVE_SOURCE_ADD_TYPE: [
      {
        value: enums.PBVideoType.VT_OUTER_CHAIN,
        text: '外链（跳至其他平台）'
      },
      {
        value: enums.PBVideoType.VT_VIDEO_SOURCE,
        text: '视频源（可内嵌播放）'
      }
    ],
    LIVE_SOURCE_ADD_STATUS: [
      {
        value: true,
        text: '已启用'
      },
      {
        value: false,
        text: '已禁用'
      }
    ],
    LIVE_CHOICE_LIVE: [
      {
        value: 0,
        text: '合作方'
      },
      {
        value: 1,
        text: '显示名称'
      }
    ],

    // 拉流源的拉流状态
    LIVE_PULL_STATUS: [
      {
        value: enums.PBLivePullStatus.LPS_DEFAULT,
        text: '初始状态'
      },
      {
        value: enums.PBLivePullStatus.LPS_PULLING,
        text: '拉流中'
      },
      {
        value: enums.PBLivePullStatus.LPS_FAILURE,
        text: '拉流失败'
      },
      {
        value: enums.PBLivePullStatus.LPS_END,
        text: '拉流结束'
      }
    ],

    // 通用管理--> 用户列表
    USER_LIST_CONSULTING_QUOTATION: [
      {
        value: enums.PBBoolValue.BOOL_NONE,
        text: '全部'
      },
      {
        value: enums.PBBoolValue.BOOL_TRUE,
        text: '有'
      },
      {
        value: enums.PBBoolValue.BOOL_FALSE,
        text: '无'
      }
    ],
    USER_LIST_IS_CUSTOMER: [
      {
        value: enums.PBBoolValue.BOOL_NONE,
        text: '全部'
      },
      {
        value: enums.PBBoolValue.BOOL_TRUE,
        text: '是'
      },
      {
        value: enums.PBBoolValue.BOOL_FALSE,
        text: '否'
      }
    ],
    USER_LIST_TRY_STATUS: [
      {
        value: -1,
        text: '全部'
      },
      {
        value: enums.PBUserTryStatus.UTS_NOT_TRY,
        text: '未试用'
      },
      {
        value: enums.PBUserTryStatus.UTS_TRYING,
        text: '试用中'
      },
      {
        value: enums.PBUserTryStatus.UTS_TRY_END,
        text: '试用结束'
      }
    ],
    USER_LIST_COOPERATION_STATUS: [
      {
        text: '全部',
        value: -1
      },
      {
        text: '未合作',
        value: enums.PBUserCooperationStatus.UCS_NOT_COOPERATION
      },
      {
        text: '合作中',
        value: enums.PBUserCooperationStatus.UCS_IN_COOPERATION
      },
      {
        text: '接口过期',
        value: enums.PBUserCooperationStatus.UCS_INTERFACE_EXPIRED
      },
      {
        text: '已流失',
        value: enums.PBUserCooperationStatus.UCS_LOST
      }
    ],
    // 企业认证状态
    ENTERPRISE_AUTH_STATUS: [
      {
        text: '全部',
        value: -1
      },
      {
        text: '未提交',
        value: enums.PBEnterpriseAuthStatus.EAS_UN_COMMIT
      },
      {
        text: '待审核',
        value: enums.PBEnterpriseAuthStatus.EAS_CHECK_PENDING
      },
      {
        text: '已通过',
        value: enums.PBEnterpriseAuthStatus.EAS_PASS
      },
      {
        text: '认证失败',
        value: enums.PBEnterpriseAuthStatus.EAS_FAIL
      },
      {
        text: '已忽略',
        value: enums.PBEnterpriseAuthStatus.EAS_IGNORE
      }
    ],
    USER_LIST_INPUT_TYPE: [
      {
        text: '用户ID',
        value: enums.PBSearchUserKey.SUK_USER_ID
      },
      {
        text: '绑定手机',
        value: enums.PBSearchUserKey.SUK_MOBILE
      },
      {
        text: '绑定邮箱',
        value: enums.PBSearchUserKey.SUK_EMAIL
      },
      {
        text: '最后登录IP',
        value: enums.PBSearchUserKey.SUK_LOGIN_IP
      },
      {
        text: '注册IP',
        value: enums.PBSearchUserKey.SUK_REG_IP
      }
    ],
    USER_LIST_DATE_TYPE: [
      {
        text: '注册时间',
        value: enums.PBSearchUserTime.SUT_REG
      },
      {
        text: '最后登录时间',
        value: enums.PBSearchUserTime.SUT_LOGIN
      }
    ],
    // 合作状态--> LIVE_DETAIL_COOPERATION_STATUS
    // 客户管理--> 咨询报价 --> 咨询处理类型
    ADVISORY_ACTION_TYPE: [
      {
        value: -1,
        text: '全部'
      },
      {
        value: enums.PBAdvisoryActionType.AAT_PENDING,
        text: '待处理'
      },
      {
        value: enums.PBAdvisoryActionType.AAT_CONNECTED,
        text: '已联系'
      },
      {
        value: enums.PBAdvisoryActionType.AAT_IGNORED,
        text: '已忽略'
      }
    ],
    ADVISORY_ACTION_DESC_CONNECTED: [
      {
        value: '已在七陌跟进',
        text: '已在七陌跟进'
      },
      {
        value: '已加QQ跟进',
        text: '已加QQ跟进'
      },
      {
        value: '已加微信跟进',
        text: '已加微信跟进'
      },
      {
        value: '其他（请备注）',
        text: '其他（请备注）'
      }
    ],
    ADVISORY_ACTION_DESC_IGNORED: [
      {
        value: '未通过验证',
        text: '未通过验证'
      },
      {
        value: '联系方式无效',
        text: '联系方式无效'
      },
      {
        value: '广告推销',
        text: '广告推销'
      },
      {
        value: '重复咨询',
        text: '重复咨询'
      },
      {
        value: '个人用户',
        text: '个人用户'
      },
      {
        value: '测试',
        text: '测试'
      },
      {
        value: '其他（请备注）',
        text: '其他（请备注）'
      }
    ],
    ADVISORY_SEARCH_TYPE: [
      {
        value: enums.PBAdvisorySearchType.AST_NAME,
        text: '企业名称'
      },
      {
        value: enums.PBAdvisorySearchType.AST_CONTACT,
        text: '联系人'
      },
      {
        value: enums.PBAdvisorySearchType.AST_QQ,
        text: 'QQ'
      },
      {
        value: enums.PBAdvisorySearchType.AST_REG_IP,
        text: '注册IP'
      },
      {
        value: enums.PBAdvisorySearchType.AST_SUB_IP,
        text: '提交IP'
      },
      {
        value: enums.PBAdvisorySearchType.AST_USER_ID,
        text: '用户ID'
      }
    ],
    PRODUCT_SUB_TYPE: [
      {
        value: enums.PBProductSubType.PST_DEFAULT,
        text: '全部'
      },
      {
        value: enums.PBProductSubType.PST_SCORE,
        text: '比分'
      },
      {
        value: enums.PBProductSubType.PST_INDEX,
        text: '指数'
      },
      {
        value: enums.PBProductSubType.PST_BETTING,
        text: '竞彩'
      },
      {
        value: enums.PBProductSubType.PST_ANIMATION,
        text: '动画'
      },
      {
        value: enums.PBProductSubType.PST_DATABASE,
        text: '资料库'
      },
      {
        value: enums.PBProductSubType.PST_DATA_ANALYSIS,
        text: '数据分析'
      }
    ],
    IS_USER: [
      {
        value: enums.PBBoolValue.BOOL_NONE,
        text: '全部'
      },
      {
        value: enums.PBBoolValue.BOOL_TRUE,
        text: '是'
      },
      {
        value: enums.PBBoolValue.BOOL_FALSE,
        text: '否'
      }
    ],
    IS_TEST: [
      {
        text: '全部',
        value: enums.PBSearchUserType.SEARCH_ALL
      },
      {
        text: '是',
        value: enums.PBSearchUserType.SEARCH_TEST
      },
      {
        text: '否',
        value: enums.PBSearchUserType.SEARCH_REAL
      }
    ],
    CHURN_RECORD_SEARCH_TYPE: [
      {
        value: enums.PBChurnRecordSearchType.CRS_CUSTOMER_NAME,
        text: '客户名称'
      },
      {
        value: enums.PBChurnRecordSearchType.CRS_PRODUCT_NAME,
        text: '产品名称'
      },
      {
        value: enums.PBChurnRecordSearchType.CRS_RECORD_ID,
        text: '记录ID'
      }
    ],
    // 客户管理--> 流失记录
    CHURN_RECORD_TIME_TYPE: [
      {
        value: enums.PBChurnRecordTimeType.CRT_CHURN_TIME,
        text: '流失时间'
      },
      {
        value: enums.PBChurnRecordTimeType.CRT_COOPERATION_TIME,
        text: '合作时间'
      }
    ],
    FOLLOW_UP_TYPE: [
      {
        value: true,
        text: '有'
      },
      {
        value: false,
        text: '无'
      }
    ],
    CHURN_REASON: [
      {
        value: enums.PBChurnReason.CR_DEFAULT,
        text: '默认'
      },
      {
        value: enums.PBChurnReason.CR_BUSINESS_CHANGE,
        text: '业务变更'
      },
      {
        value: enums.PBChurnReason.CR_DATA_QUALITY,
        text: '数据质量问题'
      },
      {
        value: enums.PBChurnReason.CR_NOT_CONTACT,
        text: '无法联系'
      },
      {
        value: enums.PBChurnReason.CR_FUNDING,
        text: '经费问题'
      },
      {
        value: enums.PBChurnReason.CR_OTHER,
        text: '其它'
      }
    ],
    productTypeText: [
      {
        text: '足球',
        value: protoNested.fw.PBProductType.PT_FOOTBALL
      },
      {
        text: '篮球',
        value: protoNested.fw.PBProductType.PT_BASKETBALL
      },
      {
        text: '网球',
        value: protoNested.fw.PBProductType.PT_TENNIS
      },
      {
        text: '美式足球',
        value: protoNested.fw.PBProductType.PT_AMERICAN_FOOTBALL
      },
      {
        text: '电竞',
        value: protoNested.fw.PBProductType.PT_EG_SPORTS
      }
    ],
    // 试用状态
    USER_TRY_STATUS: [
      {
        value: -1,
        text: '全部'
      },
      {
        value: enums.PBUserTryStatus.UTS_NOT_TRY,
        text: '未试用'
      },
      {
        value: enums.PBUserTryStatus.UTS_TRYING,
        text: '试用中'
      },
      {
        value: enums.PBUserTryStatus.UTS_TRY_END,
        text: '试用结束'
      }
    ],
    // 文档格式
    DOC_FORMAT_TYPE: [
      {
        value: enums.PBDocFormatType.DF_DEFAULT,
        text: '默认'
      },
      {
        value: enums.PBDocFormatType.DF_XML,
        text: 'XML'
      },
      {
        value: enums.PBDocFormatType.DF_JSON,
        text: 'JSON'
      },
      {
        value: enums.PBDocFormatType.DF_XML_OR_JSON,
        text: 'XML/JSON'
      }
    ],
    RETURN_PARAM_TYPE: [
      {
        value: enums.PBReturnParamType.RPT_XML,
        text: 'XML'
      },
      {
        value: enums.PBReturnParamType.RPT_TXT,
        text: 'TXT'
      },
      {
        value: enums.PBReturnParamType.RPT_JSON,
        text: 'JSON'
      },
      {
        value: enums.PBReturnParamType.RPT_PDF,
        text: 'PDF'
      }
    ],
    CONFIG_TYPE: [
      {
        value: -1,
        text: '全部'
      },
      {
        value: enums.PBConfigType.UCT_KEY,
        text: '秘钥'
      },
      {
        value: enums.PBConfigType.UCT_DOMAIN,
        text: '域名白名单'
      },
      {
        value: enums.PBConfigType.UCT_IP,
        text: 'IP白名单'
      }
    ],
    CONFIG_STATUS_TEXT: [
      {
        value: enums.PBUserConfigStatus.UCS_TO_BE_CONFIG,
        text: '待配置'
      },
      {
        value: enums.PBUserConfigStatus.UCS_TO_BE_OPEN,
        text: '待开启'
      },
      {
        value: enums.PBUserConfigStatus.UCS_IN_USE,
        text: '已启用'
      },
      {
        value: enums.PBUserConfigStatus.UCS_DISABLED,
        text: '不可用'
      }
    ],
    MATERIAL_TYPE: [
      {
        value: enums.PBMaterialType.MT_GRANDSTAND,
        text: '看台'
      },
      {
        value: enums.PBMaterialType.MT_SITE,
        text: '场地'
      },
      {
        value: enums.PBMaterialType.MT_FENCE,
        text: '围栏'
      },
      {
        value: enums.PBMaterialType.MT_MID_LINE,
        text: '中线'
      }
    ],
    TRANSTER_TYPE: [
      {
        text: '[公对公]',
        value: enums.PBAccountType.ACCOUNT_TYPE_PUBLIC
      },
      {
        text: '[私对公]',
        value: enums.PBAccountType.ACCOUNT_TYPE_PRIVATE
      },
      {
        text: '[支付宝]',
        value: enums.PBAccountType.ACCOUNT_TYPE_ALIPAY
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/utils/mapper.js